import { FC, useCallback } from 'react';

import SelectBase, { SelectBaseProps } from 'components/SelectBase';

import { useFilter } from 'lib';
import { SelectChangeEvent } from '@mui/material/Select';

import { MarkupType } from '__generated__/PackageEditMain_package.graphql';

type Props = Omit<SelectBaseProps, 'options'> & {};

type Option = {
  value: MarkupType | '';
  label: string;
};

const options: Option[] = [
  { value: '', label: 'Rodyti visus' },
  { value: 'STANDARD', label: 'Standartinis' },
  { value: 'FIXED', label: 'Fixuotas' },
];

const PackageMarkupTypeFilter: FC<Props> = props => {
  const [value, setValue] = useFilter('markupType');

  const handleChange = useCallback(
    (event: SelectChangeEvent) => {
      setValue(event.target.value);
    },
    [setValue]
  );

  return (
    <SelectBase
      autoWidth
      options={options}
      value={value ?? ''}
      onChange={handleChange}
      placeholder="Antkainis"
      label="Antkainis"
      {...props}
    />
  );
};

export default PackageMarkupTypeFilter;
